import $axios from "../api/accessor";
import { $api } from "../api/api";

export interface ServiceFeeInfo {
  fee_azn: number;
  fee_usd: number;
  count: number;
}

export const PackagesService = {
  async getAllPackages(status: string, url?: string) {
    const endpoint = url || $api("get_packages", { status: status });

    let response = await $axios
      .get(endpoint, {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getPackagesHistory(id: number) {
    let response = await $axios
      .get($api("package_history", { id: id }), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async payPackages(payload: any) {
    const response = await $axios.post(
      $api("pay_packages"),
      { package_ids: payload },
      {
        headers: {
          "Accept-Language": "az",
        },
      }
    );

    return {
      data: response?.data ?? [],
      status: response?.status,
    };
  },

  async payPackagesWithBank(packageIds: number[], cardId?: number, paymentProvider?: string) {
    const payload: { package_ids: number[]; card_id?: number; payment_provider?: string } = {
      package_ids: packageIds,
    };
    if (cardId) {
      payload.card_id = cardId;
    }
    if (paymentProvider) {
      payload.payment_provider = paymentProvider;
    }

    const response = await $axios.post($api("pay_packages_bank"), payload, {
      headers: {
        "Accept-Language": "az",
      },
    });

    return {
      data: response?.data ?? [],
      status: response?.status,
    };
  },

  async getAllPackagesBaku() {
    let response = await $axios
      .get($api("get_packesBaku"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAllPackagesOnTheWay() {
    let response = await $axios
      .get($api("get_packesonTheway"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAllPackagesWareHouse() {
    let response = await $axios
      .get($api("get_packesWareHouse"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAllPackagesDelivered() {
    let response = await $axios
      .get($api("get_packesDelivered"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getServiceFee(packageIds: number[]): Promise<ServiceFeeInfo> {
    const params = new URLSearchParams();
    packageIds.forEach((id) => params.append("package_ids[]", String(id)));
    const response = await $axios.get(
      `${$api("packages_service_fee")}?${params.toString()}`
    );
    return response.data as ServiceFeeInfo;
  },

  async getAllPackagesType() {
    let response = await $axios
      .get($api("get_packeagesType"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
